import { Routes } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { UtleieboligComponent } from "./tilskudd/utleiebolig/utleiebolig.component";
import { TilstandsvurderingComponent } from "./tilskudd/tilstandsvurdering/tilstandsvurdering.component";
import { GrunnlanComponent } from "./lan/grunnlan/grunnlan.component";
import { BoligkvalitetComponent } from "./lan/boligkvalitet/boligkvalitet.component";
import { StudentboligComponent } from "./lan/studentbolig/studentbolig.component";
import { UtleieboliglanComponent } from "./lan/utleieboliglan/utleieboliglan.component";
import { KomigangComponent } from "./hjelp/komigang/komigang.component";
import { BostotteComponent } from "./bostotte/bostotte.component";
import { OmComponent } from "./hjelp/om/om.component";
import { BegreperComponent } from "./hjelp/begreper/begreper.component";
import { StartlanComponent } from "./lan/startlan/startlan.component";
import { BarnehagelanComponent } from "./lan/barnehagelan/barnehagelan.component";
import { InvesteringstilskuddComponent } from "./tilskudd/investeringstilskudd/investeringstilskudd.component";
import { KompetansetilskuddComponent } from "./tilskudd/kompetansetilskudd/kompetansetilskudd.component";
import { DatasettcontainerComponent } from "./datasett/datasettcontainer.component";
import { KommunesideComponent } from "./kommune/nokkeltall/kommuneside.component";
import { SammenligningComponent } from "./kommune/sammenligning/sammenligning.component";
import { UtviklingComponent } from "./kommune/utvikling/utvikling.component";
import { EnergitilskuddComponent } from "./tilskudd/energitilskudd/energitilskudd.component";

export const appRoutes: Routes = [
  {
    path: "",
    component: HomeComponent,
  },
  {
    path: "bostotte",
    component: BostotteComponent,
  },
  {
    path: "lan",
    redirectTo: "lan/boligkvalitet",
    pathMatch: "full",
  },
  {
    path: "lan/grunnlan",
    component: GrunnlanComponent,
  },
  {
    path: "lan/boligkvalitet",
    component: BoligkvalitetComponent,
  },
  {
    path: "lan/startlan",
    component: StartlanComponent,
  },
  {
    path: "lan/barnehagelan",
    component: BarnehagelanComponent,
  },
  {
    path: "lan/studentbolig",
    component: StudentboligComponent,
  },
  {
    path: "lan/utleieboliglan",
    component: UtleieboliglanComponent,
  },
  {
    path: "tilskudd",
    redirectTo: "tilskudd/investeringstilskudd",
    pathMatch: "full",
  },
  {
    path: "tilskudd/utleiebolig",
    component: UtleieboligComponent,
  },
  {
    path: "tilskudd/tilstandsvurdering",
    component: TilstandsvurderingComponent,
  },
  {
    path: "tilskudd/investeringstilskudd",
    component: InvesteringstilskuddComponent,
  },
  {
    path: "tilskudd/kompetansetilskudd",
    component: KompetansetilskuddComponent,
  },
  {
    path: "tilskudd/energitilskudd",
    component: EnergitilskuddComponent,
  },
  {
    path: "datasett/datasett",
    component: DatasettcontainerComponent,
  },
  {
    path: "kommune",
    redirectTo: "kommune/nokkeltall",
    pathMatch: "full",
  },
  {
    path: "kommune/nokkeltall",
    component: KommunesideComponent,
  },
  {
    path: "kommune/sammenligning",
    component: SammenligningComponent,
  },
  {
    path: "kommune/utvikling",
    component: UtviklingComponent,
  },
  {
    path: "hjelp",
    redirectTo: "hjelp/komigang",
    pathMatch: "full",
  },
  {
    path: "hjelp/komigang",
    component: KomigangComponent,
  },
  {
    path: "hjelp/begreper",
    component: BegreperComponent,
  },
  {
    path: "hjelp/om",
    component: OmComponent,
  },
];
